var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container not-found-page"},[_c('div',{staticClass:"not-found-page"},[_c('h1',[_vm._v("404")]),_c('img',{attrs:{"src":"https://offthecouch.io/img/pandas/search.png"}}),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('general.notFound')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }